import yup from "src/validators/yup.Module";

export enum ESubModulo {
  NFCe = 1,
  NFe = 2,
  CTe = 3,
}

export enum EConfiguracaoTipo {
  IdToken = 1,
  CSC = 2,
  TipoAmbiente = 3,
  TipoEmissao = 4,
  Serie = 5,
}

export interface ConfiguracoesFiltrarParams {
  id?: number;
  subModulo?: number;
  tipoConfiguracao?: number;
  usuarioId?: number;
}

export interface ConfiguracaoCadastroDto {
  usuarioId?: number;
  usuarioNome?: string;
  subModulo?: ESubModulo | "";
  tipoConfiguracao?: EConfiguracaoTipo | "";
  configuracaoValor?: string;
}

export interface ConfiguracaoPayload {
  id?: number;
  subModulo: number;
  tipoConfiguracao: number;
  configuracaoValor: string;
  usuarioId?: number;
}

export const subModuloOptions = [
  { value: ESubModulo.NFCe, label: "NFCe" },
  { value: ESubModulo.NFe, label: "NFe" },
  { value: ESubModulo.CTe, label: "CTe" },
];

export const configuracaoOptions = {
  [ESubModulo.NFCe]: [
    { value: EConfiguracaoTipo.IdToken, label: "IdToken" },
    { value: EConfiguracaoTipo.CSC, label: "CSC" },
    { value: EConfiguracaoTipo.TipoAmbiente, label: "TipoAmbiente" },
    { value: EConfiguracaoTipo.TipoEmissao, label: "TipoEmissao" },
    { value: EConfiguracaoTipo.Serie, label: "Serie" },
  ],
  [ESubModulo.NFe]: [
    { value: EConfiguracaoTipo.TipoAmbiente, label: "TipoAmbiente" },
    { value: EConfiguracaoTipo.TipoEmissao, label: "TipoEmissao" },
    { value: EConfiguracaoTipo.Serie, label: "Serie" },
  ],
  [ESubModulo.CTe]: [
    { value: EConfiguracaoTipo.TipoAmbiente, label: "TipoAmbiente" },
    { value: EConfiguracaoTipo.TipoEmissao, label: "TipoEmissao" },
  ],
};

export const SistemaCadastroSchema = yup.object().shape({
  subModulo: yup
    .number()
    .typeError("Selecione o submódulo.")
    .required("Selecione o submódulo."),
  tipoConfiguracao: yup
    .number()
    .typeError("Selecione a configuração.")
    .required("Selecione a configuração."),
  configuracaoValor: yup
    .string()
    .required("Digite o valor da configuração.")
    .min(1, "O valor deve ter no mínimo 1 caractere."),
  usuarioId: yup
    .number()
    .nullable()
    .when("tipoConfiguracao", {
      is: (tipoConfiguracao: EConfiguracaoTipo) =>
        tipoConfiguracao === EConfiguracaoTipo.Serie,
      then: (schema) =>
        schema.required(
          "Para configuração do tipo série é obrigatório o id do usuário"
        ),
      otherwise: (schema) => schema.notRequired().nullable(),
    }),
});
